// extracted by mini-css-extract-plugin
export default {"wrapperAlertWarning":"PreTestWarningInformation_wrapperAlertWarning__OvgEU","wrapperContent":"PreTestWarningInformation_wrapperContent__ZBkht"};